(function () {
  'use strict';
  function init(root) {
    if (root.dataset.finderReady === 'true') return;
    root.dataset.finderReady = 'true';
    var state = { step: 1, header: '', coverage_width: '', curtain_top_to_floor: '', panel_layout: '', finished_look: '' };
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var continueButton = root.querySelector('[data-continue]');
    var backButton = root.querySelector('[data-back]');
    var scene = root.querySelector('[data-finder-scene]');
    var placeholder = root.querySelector('[data-finder-placeholder]');
    var configNode = root.querySelector('[data-finder-config]');
    var config = {};
    try { config = JSON.parse(configNode.textContent || '{}'); } catch (error) { config = {}; }
    var scenesNode = root.querySelector('[data-finder-scenes-v2]');
    var scenes = {};
    try { scenes = JSON.parse(scenesNode.textContent || '{}'); } catch (error) { scenes = {}; }

    function validNumber(value) { return value !== '' && Number.isFinite(Number(value)) && Number(value) > 0; }
    function currentValid() {
      if (state.step === 1) return Boolean(state.header);
      if (state.step === 2) return validNumber(state.coverage_width) && validNumber(state.curtain_top_to_floor);
      if (state.step === 3) return Boolean(state.panel_layout && state.finished_look);
      return true;
    }
    function renderScene(image, alt) {
      if (image) { scene.src = image; scene.alt = alt || ''; scene.hidden = false; placeholder.hidden = true; } else { scene.removeAttribute('src'); scene.alt = ''; scene.hidden = true; placeholder.hidden = false; }
    }
    function renderSceneForState() {
      var active = root.querySelector('[data-choice-group="header"][data-choice="' + state.header + '"]');
      var labels = { pinch_pleat: 'Pinch Pleat', back_tab: 'Back Tab', grommet: 'Grommet', pair: 'pair panels', single: 'single panel', float: 'float finish', kiss: 'kiss finish', puddle: 'puddle finish' };
      var image = '';
      var alt = 'Curtain size finder';
      var headerScenes = scenes[state.header] || {};
      if (state.step >= 3 && state.header && state.panel_layout) {
        if (state.finished_look) {
          image = headerScenes[state.panel_layout + '_' + state.finished_look] || '';
          if (image) alt = labels[state.header] + ' curtains with ' + labels[state.panel_layout] + ' and ' + labels[state.finished_look];
        }
        if (!image) {
          image = headerScenes[state.panel_layout] || '';
          if (image) alt = labels[state.header] + ' curtains with ' + labels[state.panel_layout];
        }
      }
      if (!image) {
        image = scenes.default || '';
        if (image) alt = 'Default curtain size finder scene';
      }
      renderScene(image, alt);
    }
    function updateRovingTabindex() {
      var groups = ['header', 'panel_layout', 'finished_look'];
      groups.forEach(function (group) {
        var choices = Array.prototype.slice.call(root.querySelectorAll('[data-choice-group="' + group + '"]'));
        var selected = choices.find(function (choice) { return state[group] === choice.dataset.choice; });
        choices.forEach(function (choice, index) { choice.tabIndex = choice === selected || (!selected && index === 0) ? 0 : -1; });
      });
    }
    function renderStep() {
      steps.forEach(function (step) { step.hidden = Number(step.dataset.step) !== state.step; });
      backButton.hidden = state.step <= 1 || state.step >= 4;
      continueButton.hidden = state.step >= 4;
      continueButton.textContent = state.step === 3 ? 'SEE MY SIZE' : 'CONTINUE';
      continueButton.disabled = !currentValid();
      renderSceneForState();
      root.querySelectorAll('[data-choice-group]').forEach(function (choice) { var selected = state[choice.dataset.choiceGroup] === choice.dataset.choice; choice.setAttribute('aria-checked', selected ? 'true' : 'false'); });
      updateRovingTabindex();
      if (state.step === 4) renderResult();
    }
    function renderResult() {
      var labels = { pinch_pleat: 'Pinch Pleat', back_tab: 'Back Tab', grommet: 'Grommet', pair: 'Pair Panels', single: 'Single Panel', float: 'Float', kiss: 'Kiss', puddle: 'Puddle' };
      root.querySelector('[data-result-context]').textContent = [labels[state.header], labels[state.panel_layout], labels[state.finished_look]].join(' · ');
      var coverage = Number(state.coverage_width);
      var topToFloor = Number(state.curtain_top_to_floor);
      var panelWidth = state.panel_layout === 'pair' ? coverage / 2 : coverage;
      var lengthAdjustment = state.finished_look === 'float' ? -1 : state.finished_look === 'puddle' ? 1 : 0;
      var targetLength = topToFloor + lengthAdjustment;
      function formatNumber(value) { return String(Number(value.toFixed(4))); }
      var result = formatNumber(panelWidth) + '"W × ' + formatNumber(targetLength) + '"L';
      root.querySelector('[data-result-size]').textContent = result;
      root.querySelector('[data-target-size]').textContent = result + (state.panel_layout === 'pair' ? ' per panel' : '');
      root.querySelector('[data-result-panel-label]').textContent = state.panel_layout === 'pair' ? 'PER PANEL' : 'SINGLE PANEL';
      var destination = config.destinations && config.destinations[state.header];
      var cta = root.querySelector('[data-shop-cta]');
      if (destination) { cta.href = destination; cta.hidden = false; } else { cta.removeAttribute('href'); cta.hidden = true; }
    }
    root.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-choice-group]');
      if (choice && root.contains(choice)) { state[choice.dataset.choiceGroup] = choice.dataset.choice; renderStep(); return; }
      if (event.target.closest('[data-continue]') && currentValid()) { state.step = Math.min(4, state.step + 1); renderStep(); return; }
      if (event.target.closest('[data-back]')) { state.step = Math.max(1, state.step - 1); renderStep(); return; }
      if (event.target.closest('[data-start-over]')) { state = { step: 1, header: '', coverage_width: '', curtain_top_to_floor: '', panel_layout: '', finished_look: '' }; root.querySelectorAll('[data-measurement]').forEach(function (input) { input.value = ''; }); renderScene('', ''); renderStep(); }
    });
    root.addEventListener('input', function (event) { var input = event.target.closest('[data-measurement]'); if (!input) return; state[input.dataset.measurement] = input.value; continueButton.disabled = !currentValid(); });
    root.addEventListener('keydown', function (event) {
      var choice = event.target.closest('[data-choice-group]');
      if (!choice) return;
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); choice.click(); return; }
      var direction = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
      if (direction) {
        event.preventDefault();
        var choices = Array.prototype.slice.call(root.querySelectorAll('[data-choice-group="' + choice.dataset.choiceGroup + '"]'));
        var index = choices.indexOf(choice);
        var next = choices[(index + direction + choices.length) % choices.length];
        next.click();
        next.focus();
      }
    });
    renderStep();
  }
  document.querySelectorAll('[data-topfinel-size-finder]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { var root = event.target.querySelector('[data-topfinel-size-finder]'); if (root) init(root); });
}());
